var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    { ref: "popover", attrs: { width: "400", trigger: "click" } },
    [
      _c(
        "el-row",
        [
          _c(
            "el-form",
            { ref: "form", attrs: { size: "mini", "label-width": "70px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("panel.video_type") } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.streamMediaInfoTemp.videoType,
                        callback: function ($$v) {
                          _vm.$set(_vm.streamMediaInfoTemp, "videoType", $$v)
                        },
                        expression: "streamMediaInfoTemp.videoType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "flv" } }, [
                        _vm._v("FLV"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#909399",
                        "font-size": "8px",
                        "margin-left": "3px",
                      },
                    },
                    [
                      _vm._v(
                        "\n          Tips:" +
                          _vm._s(_vm.$t("panel.live_tips")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm.streamMediaInfoTemp.videoType === "flv"
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("panel.is_live") } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value:
                                  _vm.streamMediaInfoTemp[
                                    _vm.streamMediaInfoTemp.videoType
                                  ].isLive,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.streamMediaInfoTemp[
                                      _vm.streamMediaInfoTemp.videoType
                                    ],
                                    "isLive",
                                    $$v
                                  )
                                },
                                expression:
                                  "streamMediaInfoTemp[streamMediaInfoTemp.videoType].isLive",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v(_vm._s(_vm.$t("panel.yes"))),
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v(_vm._s(_vm.$t("panel.no"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      !_vm.streamMediaInfoTemp[
                        _vm.streamMediaInfoTemp.videoType
                      ].isLive
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("panel.play_frequency") },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value:
                                      _vm.streamMediaInfoTemp[
                                        _vm.streamMediaInfoTemp.videoType
                                      ].loop,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.streamMediaInfoTemp[
                                          _vm.streamMediaInfoTemp.videoType
                                        ],
                                        "loop",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "streamMediaInfoTemp[streamMediaInfoTemp.videoType].loop",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v(_vm._s(_vm.$t("panel.play_once"))),
                                  ]),
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v(_vm._s(_vm.$t("panel.play_circle"))),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("panel.video_links") } },
                        [
                          _c("el-input", {
                            model: {
                              value:
                                _vm.streamMediaInfoTemp[
                                  _vm.streamMediaInfoTemp.videoType
                                ].url,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.streamMediaInfoTemp[
                                    _vm.streamMediaInfoTemp.videoType
                                  ],
                                  "url",
                                  $$v
                                )
                              },
                              expression:
                                "streamMediaInfoTemp[streamMediaInfoTemp.videoType].url",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v(_vm._s(_vm.$t("panel.confirm")))]
                  ),
                  _c("el-button", { on: { click: _vm.onClose } }, [
                    _vm._v(_vm._s(_vm.$t("panel.cancel"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("i", {
        staticClass: "icon iconfont icon-chaolianjie",
        attrs: { slot: "reference" },
        slot: "reference",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }